// extracted by mini-css-extract-plugin
export const headerLayout = "header-bloc-module--headerLayout--1oNXf";
export const textLayout = "header-bloc-module--textLayout--3XDQE";
export const title = "header-bloc-module--title--9F46G";
export const description = "header-bloc-module--description--26Ysc";
export const info = "header-bloc-module--info--2yiGW";
export const imgContainer = "header-bloc-module--imgContainer--1mKzB";